<template>
	<a
		:href="iconPath"
		:download="`blobs-${icon}`"
		class="text-center bg-white p-4 rounded-md shadow-md dark:bg-gray-600 outline-none focus:ring ring-green-500 ring-opacity-40"
	>
		<img :src="iconPath" class="inline-block h-20 w-20" :alt="icon" />
		<p class="text-xs text-gray-800 mt-6 dark:text-gray-300">{{ icon }}</p>
	</a>
</template>

<script>
export default {
	props: ["icon", "decorations"],
	computed: {
		iconPath() {
			return `/icons/${this.decorations ? "with" : "no"}-decorations/${
				this.icon
			}.svg`;
		},
	},
};
</script>
